<div class="pl-header">
  <button
    *ngIf="navigation"
    class="pl-header__toggle"
    [plNavigationTrigger]="navigation"
    aria-label="Toggle navigation"
  >
    <mat-icon>menu</mat-icon>
  </button>
  <a class="pl-header__logo" [routerLink]="homeLink" aria-label="Kanga Home">
    <img src="/assets/img/brand/kanga-logo-blue.svg" alt="Kanga" height="32" />
  </a>
  <mat-chip *ngIf="previewTicket" class="preview-chip">{{
    previewTicket
  }}</mat-chip>
  <div class="pl-header__spacer"></div>
  <pl-current-license></pl-current-license>
  <pl-account-dropdown></pl-account-dropdown>
</div>
